import { render } from "./kba_step.vue?vue&type=template&id=74185d0f"
import script from "./kba_step.vue?vue&type=script&lang=js"
export * from "./kba_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/kba_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74185d0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74185d0f', __exports__)) {
    api.reload('74185d0f', __exports__)
  }
  
  module.hot.accept("./kba_step.vue?vue&type=template&id=74185d0f", () => {
    api.rerender('74185d0f', render)
  })

}


export default __exports__